import React from "react";
import styled, { css } from "styled-components";

function Icon(props) {
  return <i className={`material-icons ${props.className}`}>{props.icon}</i>;
}

const StyledIcon = styled(Icon)`
  animation: ${props => (props.animation === "rotate" ? "rotate" : "none")} 2s
    infinite;

  color: ${props => props.theme[props.color]};
  position: relative;

  ${props => {
    switch (props.size) {
      case "medium":
        return css`
          font-size: 16px;
        `;

      case "small":
        return css`
          font-size: 12px;
        `;

      case "smallest":
        return css`
          font-size: 10px;
        `;

      default:
        return null;
    }
  }} @keyframes rotate {
    0% {
      transform: rotate(0);
    }

    20% {
      transform: rotate(180deg);
    }

    40% {
      transform: rotate(180deg);
    }

    60% {
      transform: rotate(0deg);
    }
  }

  ${props =>
    props.marked &&
    css`
      &:after {
        content: "";
        width: 6px;
        height: 6px;
        background-color: ${props => props.theme.high};
        border-radius: 100%;
        position: absolute;
        top: -5px;
        right: -5px;

        font-size: 10px;

        display: flex;
        align-items: center;
        justify-content: center;
      }
    `}
`;

export default StyledIcon;
